import mock from "@/fake-db/mock.js"
import axios from "../../../http/axios/index.js"
const data = {
  users: [
    
    

  ],
  
}


axios.get("http://127.0.0.1:8000/api/getdomaine").then(resp => {
data.users = resp.data
  
console.log("5",data.users[0].id);})





mock.onGet("/api/domaine/users").reply(() => {
  return [200, JSON.parse(JSON.stringify(data.users)).reverse()];
});

// GET: Fetch Single User Details
mock.onGet(/\/api\/domaine\/users\/\d+/).reply((request) => {

  const userId = request.url.substring(request.url.lastIndexOf("/")+1)

  let user = data.users.find((user) => user.id == userId)

  return user ? [200, JSON.parse(JSON.stringify(user))] : [404]
})

// // POST : Add new Item
// mock.onPost("/api/data-list/products/").reply((request) => {

//   // Get event from post data
//   let item = JSON.parse(request.data).item

//   const length = data.products.length
//   let lastIndex = 0
//   if(length){
//     lastIndex = data.products[length - 1].id
//   }
//   item.id = lastIndex + 1

//   data.products.push(item)

//   return [201, {id: item.id}]
// })

// // Update Product
 mock.onPost(/\/api\/domaine\/products\/\d+/).reply((request) => {

   const userId = request.url.substring(request.url.lastIndexOf("/")+1)

   let user = data.users.find((user) => user.id == userId)
   Object.assign(user, JSON.parse(request.data).user)
   console.log(user)
   return [200, user]
 })

// // DELETE: Remove Item
mock.onDelete(/\/api\/domaine\/users\/\d+/).reply((request) => {

  const userId = request.url.substring(request.url.lastIndexOf("/")+1)

  const itemIndex = data.users.findIndex((p) => p.id == userId)
  data.users.splice(itemIndex, 1)
  return [200]
})
